var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "mr-2",
    "data-name": "sign-out",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 1H6.5C6.77614 1 7 1.22386 7 1.5C7 1.77614 6.77614 2 6.5 2L4.5 2C3.11929 2 2 3.11929 2 4.5L2 11.5C2 12.8807 3.11929 14 4.5 14H6.5C6.77614 14 7 14.2239 7 14.5C7 14.7761 6.77614 15 6.5 15H4.5C2.567 15 1 13.433 1 11.5V4.5C1 2.567 2.567 1 4.5 1ZM14.8536 8.35325C15.0488 8.15799 15.0488 7.84141 14.8536 7.64614L10.7069 3.49939C10.5116 3.30413 10.195 3.30413 9.99976 3.49939C9.80449 3.69465 9.80449 4.01123 9.99975 4.2065L10.2751 4.4818C10.8353 5.04206 10.4385 6 9.64619 6L6.5 6C6.22386 6 6 6.22386 6 6.5C6 6.77614 6.22386 7 6.5 7L12.3791 7C12.6443 7 12.8985 7.10533 13.086 7.2928C13.4764 7.68321 13.4761 8.31649 13.0857 8.70689C12.8981 8.89448 12.6435 9 12.3782 9H6.5C6.22386 9 6 9.22386 6 9.5C6 9.77614 6.22386 10 6.5 10H9.64609C10.4382 10 10.8349 10.9577 10.2748 11.5178L9.99964 11.7929C9.80438 11.9882 9.80437 12.3047 9.99963 12.5C10.1949 12.6953 10.5115 12.6953 10.7067 12.5L14.8536 8.35325Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/sign-out.d1b5ca9a3beda5c575a03c19db5da6cf.svg";
export { ForwardRef as ReactComponent };